import { CustomCard } from '@app/shared/components';
import {
	AppScreen,
	ScreenSizeEnum,
	StackNavigation,
	useAppDevice,
	useAppTheme,
} from '@itrustcapital/ui';
import { useNavigation } from '@react-navigation/native';
import { Text } from '@ui-kitten/components';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import {
	StakingEnrollmentsScreenProvider,
	useStakingEnrollmentsScreenState,
} from './StakingEnrollmentsScreenProvider';
import { StakingBalances } from './components/StakingBalances';
import { StakingEnrollmentsFilterForm } from './components/StakingEnrollmentsFilterForm';
import { StakingEnrollmentsTable } from './components/StakingEnrollmentsTable';
import { StakingScreenProvider, useStakingScreenState } from '../Staking/StakingScreenProvider';

export function StakingEnrollmentsScreen() {
	const styles = useCustomStyles();
	const dynamicStyles = useDynamicStyles();
	const navigation = useNavigation<StackNavigation>();
	const stakingState = useStakingScreenState();
	const enrollmentsState = useStakingEnrollmentsScreenState();

	React.useEffect(() => {
		navigation.setOptions({
			header: () => null,
		});
	}, []);

	return (
		<StakingScreenProvider value={stakingState}>
			<AppScreen
				noMarginBottom
				noMaxWidth
				style={[styles.main.container, dynamicStyles.main.container]}
			>
				<StakingEnrollmentsScreenProvider value={enrollmentsState}>
					<View style={styles.main.content}>
						<View style={styles.header.container}>
							<View style={styles.header.row}>
								<Text category="h3" style={styles.header.text}>
									Staking Enrollments
								</Text>
							</View>
						</View>

						<CustomCard>
							<StakingBalances />
							<StakingEnrollmentsFilterForm />
							<StakingEnrollmentsTable />
						</CustomCard>
					</View>
				</StakingEnrollmentsScreenProvider>
			</AppScreen>
		</StakingScreenProvider>
	);
}

function useCustomStyles() {
	const theme = useAppTheme();

	return {
		main: StyleSheet.create({
			container: {
				marginBottom: 20,
			},
			content: {
				flex: 1,
			},
			card: {
				marginBottom: 8,
				paddingTop: 0,
				backgroundColor: theme['color-basic-1000'],
			},
			spinner: {
				width: '100%',
				alignItems: 'center',
			},
		}),
		header: StyleSheet.create({
			container: {
				padding: 8,
				paddingBottom: 20,
				justifyContent: 'space-between',
				flexDirection: 'row',
				flexWrap: 'wrap',
			},
			text: {
				textTransform: 'capitalize',
			},
			row: {
				flexDirection: 'row',
				alignItems: 'center',
				flexWrap: 'wrap',
			},
			currencyText: {
				color: theme['color-basic-600'],
			},
		}),
		top: StyleSheet.create({
			row: {
				flexDirection: 'row',
				alignContent: 'center',
				gap: '8px',
				flexWrap: 'wrap',
			},
			card: {
				flex: 1,
				justifyContent: 'center',
				alignContent: 'center',
				maxWidth: 240,
				minWidth: 240,
				height: 100,
				shadowColor: theme['shadow-color-100'],
				shadowOpacity: 0.2,
				shadowOffset: { width: 0, height: 4 },
				shadowRadius: 4,
				cursor: 'default',
			},
			headerText: {
				flexDirection: 'row',
				alignItems: 'baseline',
			},
			totalValueText: {
				marginLeft: 32,
			},
			text: {
				flex: 1,
				textAlign: 'left',
				marginVertical: 10,
			},
			subtext: {
				fontSize: 15,
				marginLeft: 8,
				color: theme['color-basic-600'],
			},
			divider: {
				height: 1,
				backgroundColor: theme['color-basic-100'],
			},
		}),
	};
}

function useDynamicStyles() {
	const appDevice = useAppDevice();
	const isScreenMd = appDevice.width >= ScreenSizeEnum.md;

	return {
		main: StyleSheet.create({
			container: {
				flexDirection: isScreenMd ? 'row' : 'column',
			},
		}),
	};
}
